import { stackActions } from './stack/actions';
import { userActions } from './user/actions';
import { CLEAR_USER_CACHE } from './types';
import { ApplicationState, AppDispatch } from './';
import { ReduxieService } from '../services/reduxieService';
import { authActions } from './auth/actions';

function syncAllData() {
  return async (dispatch: AppDispatch, getState: () => ApplicationState) => {
    await dispatch(userActions.getUserInfo());
    const state = getState();
    if (state?.user?.departments) {
      await dispatch(authActions.refreshTokenIfExpired());
      await Promise.all(
        state.user.departments.map((department) =>
          Promise.all([
            dispatch(
              stackActions.uploadAllLocalStacksForDepartmentId(department.id),
            ),
            dispatch(stackActions.getStacksByDepartmentId(department.id)),
            dispatch(
              stackActions.getMeasurementCardByDepartmentId(department.id),
            ),
            dispatch(
              stackActions.updateReservedStackNumbers(
                department.id,
                state.device.deviceId,
              ),
            ),
          ]),
        ),
      );
    }
  };
}

function clearUserCache() {
  return async (dispatch: AppDispatch) => {
    dispatch({ type: CLEAR_USER_CACHE });
    return ReduxieService.clear();
  };
}

export const globalActions = {
  syncAllData,
  clearUserCache,
};
